import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { MessageV2DTO, PartnerDTO, ReceiverEnvelopeDTO } from 'support/types';
import { Badge, BadgeColor } from 'components/Display/Badge/Badge';
import { TransactionStatusDisplay } from 'components/TransactionStatusDisplay/TransactionStatusDisplay';

type PaymentReconciliationSidebarStatusBadgeProps = {
  message: MessageV2DTO;
  receiverEnvelope: ReceiverEnvelopeDTO;
  currentPartner: PartnerDTO | undefined;
};
export const PaymentReconciliationSidebarStatusBadge: FC<PaymentReconciliationSidebarStatusBadgeProps> = ({
  receiverEnvelope,
  message,
  currentPartner,
}) => {
  const { t } = useTranslation();

  if (receiverEnvelope.canForceDeliver) {
    return (
      <Badge hasDot color={BadgeColor.green} tooltip={t('paymentReconciliation:status.tooltips.readyToSync')}>
        {t('paymentReconciliation:status.labels.readyToSync')}
      </Badge>
    );
  }

  return <TransactionStatusDisplay transaction={message} currentPartner={currentPartner} />;
};
